import axios from 'axios';

const API_BASE_URL = '/api';

const creditPricingService = {
  // Get all pricing configs
  getAll: async () => {
    const response = await axios.get(`${API_BASE_URL}/admin/credit-pricing`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get active pricing config
  getActive: async () => {
    const response = await axios.get(`${API_BASE_URL}/admin/credit-pricing/active`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get pricing config by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/admin/credit-pricing/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new pricing config
  create: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/admin/credit-pricing`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Update pricing config
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/admin/credit-pricing/${id}`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete pricing config
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/admin/credit-pricing/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Activate pricing config
  activate: async (id) => {
    const response = await axios.put(`${API_BASE_URL}/admin/credit-pricing/${id}/activate`, {}, {
      withCredentials: true
    });
    return response.data;
  }
};

export default creditPricingService;

